var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1486_7766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1486_7766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 17.5C2.87435 17.5 2.48199 17.3368 2.1556 17.0104C1.82921 16.684 1.66602 16.2917 1.66602 15.8333V6.66666C1.66602 6.20832 1.82921 5.81596 2.1556 5.48957C2.48199 5.16318 2.87435 4.99999 3.33268 4.99999H6.66602V3.33332C6.66602 2.87499 6.82921 2.48263 7.1556 2.15624C7.48199 1.82985 7.87435 1.66666 8.33268 1.66666H11.666C12.1243 1.66666 12.5167 1.82985 12.8431 2.15624C13.1695 2.48263 13.3327 2.87499 13.3327 3.33332V4.99999H16.666C17.1243 4.99999 17.5167 5.16318 17.8431 5.48957C18.1695 5.81596 18.3327 6.20832 18.3327 6.66666V15.8333C18.3327 16.2917 18.1695 16.684 17.8431 17.0104C17.5167 17.3368 17.1243 17.5 16.666 17.5H3.33268ZM3.33268 15.8333H16.666V6.66666H3.33268V15.8333ZM8.33268 4.99999H11.666V3.33332H8.33268V4.99999Z",
    fill: "#1C1B1F",
    fillOpacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.8fe41e893617c9278f40d334a2536232.svg";
export { ForwardRef as ReactComponent };